<template>
  <div class="dialog_container">
    <el-dialog
      title="车辆检测记录详情"
      :visible="dialogShow"
      width="837px"
      @close="dialogClose"
      top="10vh"
      :close-on-click-modal="false"
    >
      <div class="dialog_box">
        <div class="form_title">基本信息</div>
        <ul class="info_box">
          <li>
            <div class="li_title">车牌号码：</div>
            <div class="li_text">{{dialogData.carNumber}}</div>
          </li>
          <li>
            <div class="li_title">车牌颜色：</div>
            <div class="li_text">{{dialogData.carColor}}</div>
          </li>
          <li>
            <div class="li_title">车辆类型：</div>
            <div class="li_text">{{dialogData.carNumber}}</div>
          </li>
          <li>
            <div class="li_title">厂牌类型：</div>
            <div class="li_text">{{dialogData.carNumber}}</div>
          </li>
          <li>
            <div class="li_title">车辆营运性质：</div>
            <div class="li_text">{{dialogData.carNumber}}</div>
          </li>
          <li>
            <div class="li_title">车主单位：</div>
            <div class="li_text">{{dialogData.carNumber}}</div>
          </li>
        </ul>

        <div class="form_title">检测信息</div>
        <ul class="info_box">
          <li>
            <div class="li_title">检测单位：</div>
            <div class="li_text">{{dialogData.detectCompany}}</div>
          </li>
          <li>
            <div class="li_title">检测时间：</div>
            <div class="li_text">{{dialogData.detectTime}}</div>
          </li>
          <li>
            <div class="li_title">检测类型：</div>
            <div class="li_text">{{dialogData.detectTypeStr}}</div>
          </li>
          <li>
            <div class="li_title">下次检测时间：</div>
            <div class="li_text">{{dialogData.nextDetectTime}}</div>
          </li>
          <li>
            <div class="li_title">检测结果：</div>
            <div class="li_text">{{dialogData.detectResult || '无'}}</div>
          </li>
        </ul>

        <div class="form_title">附件</div>
        <div class="uploading_box">
          <div class="certificate">
            <img :src="imgHttp + dialogData.detectFile" alt="">
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="btn btn_ok" @click="confirm">确 认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      addForm: {},
      imgHttp:"https://3z714i9315.imdo.co/"
    };
  },
  components: {},
  props: {
    dialogShow: {
      type: Boolean,
      default: false,
    },
    dialogData: {
      type: Object,
      default: {},
    },
  },
  created() {},
  methods: {
    confirm() {
      this.$emit("update:dialogShow", false);
    },
    dialogClose() {
      this.$emit("update:dialogShow", false);
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../assets/css/dialog";
.uploading_box {
  display: flex;
  flex-wrap: wrap;
  .certificate {
    width: 238px;
    height: 157px;
    border: 1px solid #e5e5e5;
    box-sizing: border-box;
    margin-bottom: 3px;
    >img{
      width: 100%;
      height: 100%;
    }
  }
}
.info_box {
  li {
    width: 398px !important;
  }
  .li_3 {
    justify-content: flex-start;
    > div {
      display: flex;
      margin-right: 15px;
    }
    .chenghao {
      font-size: 12px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/carAdmin/maintainRecord_component/detailCarMaintain.vue